export var TypeActionImprovement;
(function (TypeActionImprovement) {
    TypeActionImprovement["Buy"] = "Improvement > Buy";
    TypeActionImprovement["BuyRequest"] = "Improvement > BuyRequest";
})(TypeActionImprovement || (TypeActionImprovement = {}));
export var actionBuyImprovement = function (id, cost, buildingId, premium) {
    if (premium === void 0) { premium = false; }
    return ({
        buildingId: buildingId,
        cost: cost,
        id: id,
        premium: premium,
        type: TypeActionImprovement.Buy,
    });
};
export var actionBuyImprovementRequest = function (id, cost, buildingId, premium) { return ({
    buildingId: buildingId,
    cost: cost,
    id: id,
    premium: premium,
    type: TypeActionImprovement.BuyRequest,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/actionImprovement.ts
// module id = 416
// module chunks = 3